module.exports = __webpack_public_path__ + "img/undraw_Online_calendar_re_wk3t.a1b189ad.svg";